/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 11:34:56
 * @LastEditors: dee
 * @LastEditTime: 2022-04-21 11:34:16
 * @Description: file content
 * requiresAuth 0静默授权 1用户授权 2 无需授权 
 */
import MyRouter from "@/routers/act-wxauth";
import config from "./config";
let myRouter = new MyRouter({
  fake: config.env[process.env.VUE_APP_SERVE_ENV].routersActWxauth.fake,
  servicesActWxjssdk: config.env[process.env.VUE_APP_SERVE_ENV].servicesActWxjssdk
});

myRouter.router.addRoutes([{
    path: "/writeoff",
    name: "writeoff",
    meta: {
      title: "核销",
      requiresAuth: 1
    },
    component: () => import("./writeoff.vue")
  },
  {
    path: "/layout",
    name: "layout",
    meta: {
      title: "",
      requiresAuth: 2
    },
    component: () => import("./layout.vue"),
    children: [
      {// 首页
        path: "/index",
        name: "index",
        meta: {
          title: config.pageTitle,
          requiresAuth: 1
        },
        component: () => import("./index.vue")
      },
      {// 九宫格抽奖页
        path: "/draw",
        name: "draw",
        meta: {
          title: config.pageTitle,
          requiresAuth: 1
        },
        component: () => import("./draw.vue")
      },
      {// 大转盘抽奖页
        path: "/dzp",
        name: "dzp",
        meta: {
          title: config.pageTitle,
          requiresAuth: 1
        },
        component: () => import("./dzp.vue")
      },
      {// 活动规则
        path: "/rules",
        name: "rules",
        meta: {
          title: '活动规则',
          requiresAuth: 1
        },
        component: () =>
          import("./rules.vue")
      },
      {// 我的奖品
        path: "/myprize",
        name: "myprize",
        meta: {
          title: '我的奖品',
          requiresAuth: 1
        },
        component: () =>
          import("./myprize.vue")
      },
      {// 我的好友
        path: "/myFriends",
        name: "myFriends",
        meta: {
          title: '我的好友',
          requiresAuth: 1
        },
        component: () =>
          import("./myFriends.vue")
      },
      {// 游戏页
        path: "/game",
        name: "game",
        meta: {
          title: config.pageTitle,
          requiresAuth: 1
        },
        component: () =>
          import("./game.vue")
      },
      {// 游戏盲盒抽奖
        path: "/blindBox",
        name: "blindBox",
        meta: {
          title: config.pageTitle,
          requiresAuth: 1
        },
        component: () =>
          import("./blindBox.vue")
      },
      {// 秘钥盲盒抽奖
        path: "/secretDraw",
        name: "secretDraw",
        meta: {
          title: config.pageTitle,
          requiresAuth: 1
        },
        component: () =>
          import("./secretDraw.vue")
      },
      {// 排行榜
        path: "/ranking",
        name: "ranking",
        meta: {
          title: '排行榜',
          requiresAuth: 1
        },
        component: () =>
          import("./ranking.vue")
      },
      {// 业主专享
        path: "/key",
        name: "key",
        meta: {
          title: '业主专享',
          requiresAuth: 1
        },
        component: () =>
          import("./key.vue")
      },
      {// 优惠券列表
        path: "/coupon",
        name: "coupon",
        meta: {
          title: '组团赢好礼',
          requiresAuth: 1
        },
        component: () =>
          import("./coupon.vue")
      },
      {// 拼团列表
        path: "/team",
        name: "team",
        meta: {
          title: config.pageTitle,
          requiresAuth: 1
        },
        component: () =>
          import("./team.vue")
      },
    ]
  }
])
export default myRouter.router;